import { authentication } from "./app-database";
import { conectarFirebase } from "./app-persistance";
import { servicios } from "./properties.js";

ruteo.$inject = ["$stateProvider", "$urlRouterProvider", "$locationProvider", "$ngReduxProvider"];
const cambiarContraTemplate = "<div><react-component name='CambiarContrasena' props='state' /></div>";
const CargaMasivaTemplate = "<div><react-component name='CargaMasiva' props='state' /></div>"
const EliminarCuentaTemplate = "<div><react-component name='EliminarCuenta' props='state' /></div>";
const DatosPTemplate = "<div><react-component name='DatosContacto' props='state' /></div>";

const FormatoAvisoTemplate = "<div><react-component name='FormatoAviso' props='state' /></div>";
const FormatoAyudaTemplate = "<div><react-component name='FormatoAyuda' props='state' /></div>";
const FormatoInformacionTemplate = "<div><react-component name='FormatoInformacion' props='state' /></div>";
const FormatoReembolsoTemplate = "<div><react-component name='FormatoReembolso' props='state' /></div>";
const portalRecuperar = "<div><react-component name='PortalRecuperar' props='state' /></div>"
const registroSeguridad = "<div><react-component name='PortalRegistroSeguridad' props='state' /></div>"
const portalRegistro = "<div><react-component name='PortalRegistro' props='state' /></div>";
const MisFormatosTemplate = "<div><react-component name='MisFormatos' props='state' /></div>";


export default function ruteo($stateProvider, $urlRouterProvider, $locationProvider, $ngRedux) {
	$urlRouterProvider.when("", "/home");
	$urlRouterProvider.when("/", "/home");
	$urlRouterProvider.otherwise("/home");

	$stateProvider
		.state("private", {
			url: "",
			abstract: true,
			views: {
				"": {
					template: "<div ui-view='header'></div><div ui-view='container'></div><div ui-view='footer'></div><div ui-view='global'></div>"
				},
				"header@private": {
					template: "<div><react-component name='Header' props='state' /></div>"
				},
				"container@private": {
					template: "<div>CONTAINER</div>"
				},
				"footer@private": {
					template: "<react-component name='Carrousel' props='state' />" //"<div><react-component name='Footer' props='state' /></div>"
				},
				"global@private": {
					template: "<react-component name='ModalAlert' props='state' /><react-component name='Descargas' props='state' /><react-component name='Loader' props='state' />"
				}
			},
			resolve: {
				param: ["$rootScope", "$stateParams", "$location", function ($rootScope, $stateParams, $location) {
					$rootScope.state.location = function (sPath) {
						$rootScope.$evalAsync(function () {
							$location.path(sPath);
						});
					};
				}],
				autenticacion: ["$ngRedux", function ($ngRedux) {
					console.log("AUTENTICACION_PRIVATE");
					return new Promise(function (resolve, reject) {
						var unsubscribe = authentication.onAuthStateChanged(function (user) {
							if (user && user.isAnonymous === false) {
								$ngRedux.dispatch({ "type": "CVE_CLIENTE_UNICO", "uid": user.uid });
								conectarFirebase($ngRedux);
								resolve("AUTH_AUTHENTICATION");
							} else {
								reject("AUTH_REQUIRED");
							}
							unsubscribe();
						});
					});
				}],
				dispositivo: ["$ngRedux", function ($ngRedux) {
					$ngRedux.dispatch({ "type": "GLOBAL_DISPOSITIVO", "dispositivo": "web" });
				}]
			}
		})
		.state("public", {
			url: "",
			abstract: true,
			views: {
				"": {
					template: "<div ui-view='header'></div><div ui-view='container'></div><div ui-view='footer'></div><div ui-view='global'></div>"
				},
				"header@public": {
					template: ""// "<react-component name='PortalHeader' props='state' />"
				},
				"container@public": {
					template: "<div>CONTAINER</div>"
				},
				"footer@public": {
					template: ""// "<react-component name='PortalFooter' props='state' />"
				},
				"global@public": {
					template: "<react-component name='ModalAlert' props='state' /><react-component name='Loader' props='state' />"
				}
			},
			resolve: {
				param: ["$rootScope", "$stateParams", "$location", function ($rootScope, $stateParams, $location) {
					$rootScope.state.location = function (sPath) {
						$rootScope.$evalAsync(function () {
							$location.path(sPath);
						});
					};
				}],
				dispositivo: ["$ngRedux", function ($ngRedux) {
					$ngRedux.dispatch({ "type": "GLOBAL_DISPOSITIVO", "dispositivo": "web" });
				}]
			}
		})
		.state("app", {
			url: "",
			abstract: true,
			views: {
				"": {
					template: "<div ui-view='container'></div><div ui-view='global'></div>"
				},
				"container@app": {
					template: "<div>CONTAINER</div>"
				},
				"global@app": {
					template: "<react-component name='ModalAlert' props='state' /><react-component name='Loader' props='state' />"
				}
			},
			resolve: {
				dispositivo: ["$ngRedux", function ($ngRedux) {
					$ngRedux.dispatch({ "type": "GLOBAL_DISPOSITIVO", "dispositivo": "app" });
				}]
			}
		})

		/////////// AUTENTICACION ///////////
		.state("private.home", {
			parent: "private",
			url: "/home",
			views: {
				"container": {
					template: "<div><react-component name='Polizas' props='state' /></div>"
				}
			}
		})
		.state("private.detalle", {
			parent: "private",
			url: "/detalle",
			views: {
				"container": {
					template: "<div><react-component name='Detalle' props='state' /></div>"
				}
			}
		})
		.state("private.detallepoliza", {
			parent: "private",
			url: "/detalle/{poliza}",
			views: {
				"container": {
					template: "<div><react-component name='Detalle' props='state' /></div>"
				}
			},
			resolve: {
				loadPoliza: ["$stateParams", "$ngRedux", function ($stateParams, $ngRedux) {
					return new Promise(function (resolve, reject) {
						$ngRedux.dispatch({ "type": "SET_POLIZA_SELECCIONADA", "polizaSeleccionada": $stateParams.poliza });
						resolve("AUTH_AUTHENTICATION");
					});
				}]
			}
		})
		.state("private.miperfil", {
			parent: "private",
			url: "/mi-perfil",
			views: {
				"container": {
					template: "<div><react-component name='MiPerfil' props='state' /></div>"
				}
			}
		})
		.state('private.regimenfiscal', {
			parent: 'private',
			url: '/mi-perfil/regimen-fiscal',
			views: {
				'container': {
					template: '<div><react-component name="RegimenFiscal" props="state" /></div>'
				}
			}
		})
		/////////// SIN PREGUNTAS SECRETAS ///////////
		.state("private.datosperfil", {
			parent: "private",
			url: "/datos-personales",
			views: {
				"container": {
					template: DatosPTemplate
				}
			}
		})




		.state("private.formatos", {
			parent: "private",
			url: "/mis-formatos/{hashOne}",
			views: {
				container: {
					template: "<div><react-component name='MisFormatos' props='state' /></div>"
				},
			},
			resolve: {
				param: ["$rootScope", "$stateParams", function ($rootScope, $stateParams) {
					$rootScope.state.hashOne = $stateParams.hashOne;
				}]
			}
		})


		.state("public.datosperfil", {
			parent: "public",
			url: "/datosPersonales",
			views: {
				"container": {
					template: DatosPTemplate
				}
			},
			resolve: {
				autenticacion: autenticacion
			}
		})

		.state("private.CambiarContrasena", {
			parent: "private",
			url: "/cambiar-contrasena",
			views: {
				"container": {
					template: cambiarContraTemplate
				}
			}
		})
		.state("public.CambiarContrasena", {
			parent: "public",
			url: "/cambiarContrasena",
			views: {
				"container": {
					template: cambiarContraTemplate
				}
			},
			resolve: {
				autenticacion: autenticacion
			}
		})
		.state("public.CargaMasiva", {
			parent: "public",
			url: "/cargaMasiva",
			views: {
				"container": {
					template: CargaMasivaTemplate
				}
			},
			resolve: {
				autenticacion: autenticacion
			}
		})
		.state("private.acceso-familiar", {
			parent: "private",
			url: "/acceso-familiar",
			views: {
				"container": {
					template: "<div><react-component name='AccesoFamiliar' props='state' /></div>"
				}
			}
		})
		.state("private.eliminar-cuenta", {
			parent: "private",
			url: "/eliminar-cuenta",
			views: {
				"container": {
					template: EliminarCuentaTemplate
				}
			}
		})
		.state("public.eliminarCuenta", {
			parent: "public",
			url: "/eliminarCuenta",
			views: {
				"container": {
					template: EliminarCuentaTemplate
				}
			},
			resolve: {
				autenticacion: autenticacion
			}
		})
		.state("private.confirma-contrasenia", {
			parent: "private",
			url: "/confirma-contrasenia",
			views: {
				"container": {
					template: "<div><react-component name='ConfirmaContrasenia' props='state' /></div>"
				}
			}
		})
		.state("private.mis-tramites", {
			parent: "private",
			url: "/mis-tramites",
			views: {
				"container": {
					template: "<div><react-component name='MisTramites' props='state' /></div>"
				}
			}
		})
		.state("private.beneficios", {
			parent: "private",
			url: "/beneficios",
			views: {
				"container": {
					template: "<div><react-component name='Beneficios' props='state' /></div>"
				}
			}
		})
		.state("private.seguimiento-siniestros", {
			parent: "private",
			url: "/seguimiento-siniestros",
			views: {
				"container": {
					template: "<div><react-component name='SeguimientoSiniestros' props='state' /></div>"
				}
			}
		})
		.state("private.directorio", {
			parent: "private",
			url: "/directorio",
			views: {
				"container": {
					template: "<div><react-component name='Directorio' props='state' /></div>"
				}
			}
		})
		.state("private.centro-atencion-gnp", {
			parent: "private",
			url: "/centro-atencion-gnp",
			views: {
				"container": {
					template: "<div><react-component name='CentroAtencionGNP' props='state' /></div>"
				}
			}
		})
		/////////// SIN AUTENTICACION ///////////
		.state("public.contrato", {
			parent: "public",
			url: "/contrato",
			views: {
				"container": {
					template: "<div><react-component name='Contratos' props='state' /></div>"
				}
			},
			resolve: {
				autenticacion: autenticacion
			}
		})
		.state("public.modificar", {
			parent: "public",
			url: "/modificar/{hash}",
			views: {
				"container": {
					template: "<div><react-component name='ModificarPass' props='state' /></div>"
				}
			},
			resolve: {
				param: ["$rootScope", "$stateParams", function ($rootScope, $stateParams) {
					$rootScope.state.hash = $stateParams.hash;
				}],
				autenticacion: autenticacion
			}
		})
		.state("public.login", {
			parent: "public",
			url: "/login",
			views: {
				"container": {
					template: "<div><react-component name='PortalLogin' props='state' /></div>"
				}
			},
			resolve: {
				autenticacion: autenticacion
			}
		})
		.state("public.olvide", {
			parent: "public",
			url: "/olvide",
			views: {
				"container": {
					template: "<div><react-component name='PortalOlvide' props='state' /></div>"
				}
			},
			resolve: {
				autenticacion: autenticacion,
				load: ["$ngRedux", function ($ngRedux) {
					$ngRedux.dispatch({ "type": "STATE_PATH_PUBLIC_OLVIDE" });
				}]
			}
		})
		.state("public.recuperar-contrasenia-temporal-portal", {
			parent: "public",
			url: "/recuperar-contrasenia-temporal-portal/{hashOne}/{hashTwo}/{hashThree}/{hashFour}/{hashFive}",
			views: {
				"container": {
					template: portalRecuperar
				}
			},
			resolve: {
				param: ["$rootScope", "$stateParams", function ($rootScope, $stateParams) {
					console.log('Listo');
					$rootScope.state.hashOne = $stateParams.hashOne;
					$rootScope.state.hashTwo = $stateParams.hashTwo;
					$rootScope.state.hashThree = $stateParams.hashThree;
					$rootScope.state.hashFour = $stateParams.hashFour;
					$rootScope.state.hashFive = $stateParams.hashFive;
				}],
				autenticacion: autenticacion
			}
		})
		.state("public.recuperar-contrasenia-temporal", {
			parent: "public",
			url: "/recuperar-contrasenia-temporal/{hashOne}/{hashTwo}/{hashThree}",
			views: {
				"container": {
					template: portalRecuperar
				}
			},
			resolve: {
				param: ["$rootScope", "$stateParams", function ($rootScope, $stateParams) {
					console.log('hola');
					$rootScope.state.hashOne = $stateParams.hashOne;
					$rootScope.state.hashTwo = $stateParams.hashTwo;
					$rootScope.state.hashThree = $stateParams.hashThree;
				}],
				autenticacion: autenticacion
			}
		})
		.state("public.recuperar-contrasenia-portal", {
			parent: "public",
			url: "/recuperar-contrasenia-portal/{hashOne}/{hashTwo}/{hashThree}/{hashFour}/{hashFive}",
			views: {
				"container": {
					template: portalRecuperar
				}
			},
			resolve: {
				param: ["$rootScope", "$stateParams", function ($rootScope, $stateParams) {
					console.log('HOLA');
					$rootScope.state.hashOne = $stateParams.hashOne;
					$rootScope.state.hashTwo = $stateParams.hashTwo;
					$rootScope.state.hashThree = $stateParams.hashThree;
					$rootScope.state.hashFour = $stateParams.hashFour;
					$rootScope.state.hashFive = $stateParams.hashFive;
				}],
				autenticacion: autenticacion
			}
		})
		.state("public.recuperar-contrasenia", {
			parent: "public",
			url: "/recuperar-contrasenia/{hashOne}/{hashTwo}/{hashThree}",
			views: {
				"container": {
					template: portalRecuperar
				}
			},
			resolve: {
				param: ["$rootScope", "$stateParams", function ($rootScope, $stateParams) {
					$rootScope.state.hashOne = $stateParams.hashOne;
					$rootScope.state.hashTwo = $stateParams.hashTwo;
					$rootScope.state.hashThree = $stateParams.hashThree;
				}],
				autenticacion: autenticacion
			}
		})
		.state("public.gnp-login-invitacion", {
			parent: "public",
			url: "/login-invitacion/{hashOne}/{hashTwo}/{email}",
			views: {
				"container": {
					template: "<div><react-component name='PortalLogin' props='state' /></div>"
				}
			},
			resolve: {
				loadHash: ["$stateParams", "$ngRedux", function ($stateParams, $ngRedux) {
					return new Promise(function (resolve, reject) {
						$ngRedux.dispatch({ "type": "LOGIN_SET_ACCESO_FAMILIAR", "accesoFamiliar": $stateParams.email });
						$ngRedux.dispatch({ "type": "REGISTRO_FAMILIAR_HASH", "hashOne": $stateParams.hashOne, "hashTwo": $stateParams.hashTwo });
						resolve("AUTH_AUTHENTICATION");
					});
				}],
				autenticacion: autenticacion
			}
		})
		.state("public.gnp-registro", {
			parent: "public",
			url: "/gnp/registro",
			views: {
				"container": {
					template: portalRegistro
				},
				resolve: {
					autenticacion: autenticacion
				}
			},
			resolve: {
				clear: () => {
					console.log("Limpiando aviso y medios");
					localStorage.removeItem("aceptarAviso");
					localStorage.removeItem("mediosElectronicos");
				},
				autenticacion: autenticacion
			}
		})
		.state("public.gnp-registro-reingenieria", {
			parent: "public",
			url: "/gnp/registro-reingenieria",
			views: {
				"container": {
					template: portalRegistro
				},
				resolve: {
					autenticacion: autenticacion
				}
			},
			resolve: {
				clear: () => {
					console.log("Limpiando aviso y medios de reingeneria");
					localStorage.removeItem("aceptarAviso");
					localStorage.removeItem("mediosElectronicos");
				},
				autenticacion: autenticacion
			}
		})
		.state("public.gnp-registro-reingenieria-inconcluso", {
			parent: "public",
			url: "/gnp/registro-reingenieria-inconcluso/{hashOne}/{hashTwo}",
			views: {
				"container": {
					template: portalRegistro
				}
			},
			resolve: {
				param: ["$rootScope", "$stateParams", function ($rootScope, $stateParams) {
					$rootScope.state.hashOne = $stateParams.hashOne;
					$rootScope.state.hashTwo = $stateParams.hashTwo;
				}],
				autenticacion: autenticacion
			}
		})
		.state("public.gnp-olvide-contrasenia", {
			parent: "public",
			url: "/gnp/gnp-olvide-contrasenia",
			views: {
				"container": {
					template: "<div><react-component name='GnpOlvideContrasenia' props='state' /></div>"
				}
			},
			resolve: {
				autenticacion: autenticacion
			}
		})
		.state("public.gnp-olvide-contrasenia-reingenieria", {
			parent: "public",
			url: "/gnp/gnp-olvide-contrasenia-reingenieria",
			views: {
				"container": {
					template: "<div><react-component name='GnpOlvideContrasenia' props='state' /></div>"
				}
			},
			resolve: {
				autenticacion: autenticacion
			}
		})
		.state("public.gnp-registro-asistido", {
			parent: "public",
			url: "/gnp/registro-asistido",
			views: {
				"container": {
					template: "<div><react-component name='PortalRegistroAsistido' props='state' /></div>"
				}
			},
			resolve: {
				autenticacion: autenticacion
			}
		})
		.state("public.gnp-registro-seguridad", {
			parent: "public",
			url: "/gnp/registro-seguridad/{hashOne}/{hashTwo}/{hashThree}",
			views: {
				"container": {
					template: registroSeguridad
				}
			},
			resolve: {
				param: ["$rootScope", "$stateParams", function ($rootScope, $stateParams) {
					$rootScope.state.hashOne = $stateParams.hashOne;
					$rootScope.state.hashTwo = $stateParams.hashTwo;
					$rootScope.state.hashThree = $stateParams.hashThree;
				}],
				autenticacion: autenticacion
			}
		})
		.state("public.gnp-registro-completo", {
			parent: "public",
			url: "/gnp/registro-completo",
			views: {
				"container": {
					template: "<div><react-component name='PortalRegistroCompleto' props='state' /></div>"
				}
			},
			resolve: {
				autenticacion: autenticacion
			}
		})
		.state("public.gnp-registro-familiar", {
			parent: "public",
			url: "/registro-familiar/{hashOne}/{hashTwo}/{email}",
			views: {
				"container": {
					template: "<div><react-component name='RegistroFamiliarPortal' props='state' /></div>"
				}
			},
			resolve: {
				param: ["$rootScope", "$stateParams", function ($rootScope, $stateParams) {
					return new Promise(function (resolve, reject) {
						$rootScope.state.hashOne = $stateParams.hashOne;
						$rootScope.state.hashTwo = $stateParams.hashTwo;
						$rootScope.state.email = $stateParams.email;

						resolve(true);
					});
				}],
				autenticacion: autenticacion
			}
		})
		// Inicio Registro Express
		.state("public.gnp-registro-express", {
			parent: "public",
			url: "/gnp/registro-agt/{hashOne}",
			views: {
				"container": {
					template: "<div><react-component name='GnpRegistroExpress' props='state' /></div>"
				},
			},
			resolve: {
				param: ["$rootScope", "$stateParams", function ($rootScope, $stateParams) {
					$rootScope.state.hashOne = $stateParams.hashOne;
				}],
				autenticacion: autenticacion
			}
		})
		// Fin Registro Expres
		.state("public.gnp-servicios-videos", {
			parent: "public",
			url: "/gnp/servicios-videos",
			views: {
				"container": {
					template: "<div><react-component name='GNPServicios' props='state' /></div>"
				}
			},
			resolve: {
				video: ["$stateParams", "$rootScope", function ($stateParams, $rootScope) {
					$rootScope.state.video = 0;
				}]
			}
		})
		.state("public.gnp-servicios-detalle", {
			parent: "public",
			url: "/gnp/servicios-videos/{video}",
			views: {
				"container": {
					template: "<div><react-component name='GNPServicios' props='state' /></div>"
				}
			},
			resolve: {
				video: ["$stateParams", "$rootScope", function ($stateParams, $rootScope) {
					$rootScope.state.video = $stateParams.video ? $stateParams.video : 0;
				}]
			}
		})
		.state("public.gnp-servicios-formatos", {
			parent: "public",
			url: "/gnp/servicios-formatos",
			views: {
				"container": {
					template: "<div><react-component name='GNPServiciosFormatos' props='state' /></div>"
				}
			}
		})
		.state("public.gnp-servicios-cirugias", {
			parent: "public",
			url: "/gnp/servicios-cirugias",
			views: {
				"container": {
					template: "<div><react-component name='GNPServiciosCirugias' props='state' /></div>"
				}
			}
		})
		.state("public.gnp-servicios-condiciones-generales", {
			parent: "public",
			url: "/gnp/servicios-condiciones-generales",
			views: {
				"container": {
					template: "<div><react-component name='GNPServiciosCondicionesGral' props='state' /></div>"
				}
			}
		})

		/////////// MOBILE ///////////
		.state("app.movil-registro", {
			parent: "app",
			url: "/movil/registro",
			views: {
				"container": {
					template: portalRegistro
				}
			},
			resolve: {
				param: ["$rootScope", "$stateParams", "$ngRedux", function ($rootScope, $stateParams, $ngRedux) {
					$ngRedux.dispatch({ "type": "GLOBAL_CONECTA_MOVIL", "conectaMovil": true });
				}],
				autenticacion: autenticacionAnonima
			}
		})
		.state("app.movil-registro-seguridad", {
			parent: "app",
			url: "/movil/registro-seguridad/{hashOne}/{hashTwo}",
			views: {
				"container": {
					template: registroSeguridad
				}
			},
			resolve: {
				param: ["$rootScope", "$stateParams", "$ngRedux", function ($rootScope, $stateParams, $ngRedux) {
					$rootScope.state.hashOne = $stateParams.hashOne;
					$rootScope.state.hashTwo = $stateParams.hashTwo;
					$ngRedux.dispatch({ "type": "GLOBAL_CONECTA_MOVIL", "conectaMovil": true });
				}],
				autenticacion: autenticacionAnonima
			}
		})
		.state("app.movil-registro-asistido", {
			parent: "app",
			url: "/movil/registro-asistido",
			views: {
				"container": {
					template: "<div><react-component name='PortalRegistroAsistido' props='state' /></div>"
				}
			},
			resolve: {
				param: ["$rootScope", "$stateParams", "$ngRedux", function ($rootScope, $stateParams, $ngRedux) {
					$ngRedux.dispatch({ "type": "GLOBAL_CONECTA_MOVIL", "conectaMovil": true });
				}],
				autenticacion: autenticacionAnonima
			}
		})
		.state("app.movil-olvide", {
			parent: "app",
			url: "/movil/olvide",
			views: {
				"container": {
					template: "<div><react-component name='PortalOlvide' props='state' /></div>"
				}
			},
			resolve: {
				param: ["$rootScope", "$stateParams", "$ngRedux", function ($rootScope, $stateParams, $ngRedux) {
					$ngRedux.dispatch({ "type": "GLOBAL_CONECTA_MOVIL", "conectaMovil": true });
				}],
				autenticacion: autenticacion
			}
		})
		.state("app.movil-polizas", {
			parent: "app",
			url: "/movil/polizas",
			views: {
				"container": {
					template: "<div><react-component name='movilPolizas' props='state' /></div>"
				}
			}
		})
		.state("app.movil-polizas-agregar", {
			parent: "app",
			url: "/movil/polizas/agregar",
			views: {
				"container": {
					template: "<div><react-component name='movilPolizasAgregar' props='state' /></div>"
				}
			},
			resolve: {
				mostrarAtras: ["$ngRedux", function ($ngRedux) {
					$ngRedux.dispatch({ "type": "SET_MOSTRAR_ATRAS", "atras": true });
				}]
			}
		})
		.state("app.movil-agregar", {
			parent: "app",
			url: "/movil/agregar",
			views: {
				"container": {
					template: "<div><react-component name='movilPolizasAgregar' props='state' /></div>"
				}
			},
			resolve: {
				mostrarAtras: ["$ngRedux", function ($ngRedux) {
					$ngRedux.dispatch({ "type": "SET_MOSTRAR_ATRAS", "atras": false });
				}]
			}
		})
		.state("app.movil-detalle", {
			parent: "app",
			url: "/movil/detalle",
			views: {
				"container": {
					template: "<div><react-component name='movilPolizasDetalle' props='state' /></div>"
				}
			}
		})
		.state("app.movil-pago-KM", {
			parent: "app",
			"url": "/movil/detalle/pagoPorKM?{enabled}&{fchVigenciaInicial}&{fchVigenciaFinal}&{infIzq}&{infDer}&{isStartKmCaptured}&{numPoliza}&{numVersion}&{supIzq}&{supDer}&{startDate}&{startKm}&{startLimitDate}&{startPhoto}&{ramo}&{vin}",
			views: {
				"container": {
					template: "<div><react-component name='movilPagoPorKM' props='state' /></div>"
				}
			},
			resolve: {
				param: ["$rootScope", "$stateParams", "$ngRedux", function ($rootScope, $stateParams, $ngRedux) {
					$rootScope.state.dbkAppParams = {
						numPoliza: $stateParams.numPoliza,
						startDate: $stateParams.startDate,
						startLimitDate: $stateParams.startLimitDate,
						startKm: $stateParams.startKm,
						numVersion: $stateParams.numVersion,
						ramo: $stateParams.ramo,
						fchVigenciaInicial: $stateParams.fchVigenciaInicial,
						fchVigenciaFinal: $stateParams.fchVigenciaFinal,
						isStartKmCaptured: ($stateParams.isStartKmCaptured === "true"),
						startPhoto: $stateParams.startPhoto,
						enabled: ($stateParams.enabled === "true"),
						supIzq: Boolean($stateParams.supIzq) ? $stateParams.supIzq : null,
						supDer: Boolean($stateParams.supDer) ? $stateParams.supDer : null,
						infIzq: Boolean($stateParams.infIzq) ? $stateParams.infIzq : null,
						infDer: Boolean($stateParams.infDer) ? $stateParams.infDer : null,
						vin: Boolean($stateParams.vin) ? $stateParams.vin : null
					}
				}]
			}
		})
		.state("app.movil-pago-KM-Final", {
			parent: "app",
			"url": "/movil/detalle/pagoPorKMFinal?{numPoliza}&{terminoPoliza}&{numVersion}&{fchVigenciaInicial}&{fchVigenciaFinal}&{isStartKmCaptured}&{nombres}&{apellidoPaterno}&{apellidoMaterno}&{enabled}&{supIzq}&{supDer}&{infIzq}&{infDer}&{vin}&{isEndKmCaptured}&{endPhoto}&{endKm}",
			views: {
				"container": {
					template: "<div><react-component name='movilPagoPorKMFinal' props='state' /></div>"
				}
			},
			resolve: {
				param: ["$rootScope", "$stateParams", "$ngRedux", function ($rootScope, $stateParams, $ngRedux) {
					$rootScope.state.dbkAppParams = {
						numPoliza: $stateParams.numPoliza,
						terminoPoliza: $stateParams.terminoPoliza,
						numVersion: $stateParams.numVersion,
						fchVigenciaInicial: $stateParams.fchVigenciaInicial,
						fchVigenciaFinal: $stateParams.fchVigenciaFinal,
						isStartKmCaptured: ($stateParams.isStartKmCaptured === "true"),
						nombres: $stateParams.nombres,
						apellidoPaterno: $stateParams.apellidoPaterno,
						apellidoMaterno: $stateParams.apellidoMaterno,
						enabled: ($stateParams.enabled === "true"),
						supIzq: Boolean($stateParams.supIzq) ? $stateParams.supIzq : null,
						supDer: Boolean($stateParams.supDer) ? $stateParams.supDer : null,
						infIzq: Boolean($stateParams.infIzq) ? $stateParams.infIzq : null,
						infDer: Boolean($stateParams.infDer) ? $stateParams.infDer : null,
						vin: Boolean($stateParams.vin) ? $stateParams.vin : null,
						isEndKmCaptured: ($stateParams.isEndKmCaptured === "true"),
						endPhoto: $stateParams.endPhoto,
						endKm: $stateParams.endKm
					}
				}]
			}
		})
		.state("app.movil-consulta-KM-Final", {
			parent: "app",
			"url": "/movil/detalle/consultaKMFinal?{fchVigenciaInicial}&{fchVigenciaFinal}&{startKm}&{endKm}&{startPhoto}&{endPhoto}&{cupon}&{cuponFechaVigencia}&{cuponMonto}&{starDate}&{limitDate}&{startLimitDate}&{cuponPorcentaje}",
			views: {
				"container": {
					template: "<div><react-component name='movilConsultaKMFinal' props='state' /></div>"
				}
			},
			resolve: {
				param: ["$rootScope", "$stateParams", "$ngRedux", function ($rootScope, $stateParams, $ngRedux) {
					$rootScope.state.dbkAppParams = {
						startKm: $stateParams.startKm,
						endKm: $stateParams.endKm,
						startPhoto: $stateParams.startPhoto,
						endPhoto: $stateParams.endPhoto,
						cupon: $stateParams.cupon,
						cuponFechaVigencia: $stateParams.cuponFechaVigencia,
						cuponPorcentaje: $stateParams.cuponPorcentaje,
						cuponMonto: $stateParams.cuponMonto,
						startDate: $stateParams.startDate,
						limitDate: $stateParams.limitDate,
						startLimitDate: $stateParams.startLimitDate,
						fchVigenciaInicial: $stateParams.fchVigenciaInicial,
						fchVigenciaFinal: $stateParams.fchVigenciaFinal,


					}
				}]
			}
		})
		.state("app.movil-identidad", {
			parent: "app",
			url: "/movil/identidad",
			views: {
				"container": {
					template: "<div><react-component name='movilIdentidad' props='state' /></div>"
				}
			}
		})
		.state("app.movil-acceso-familiar", {
			parent: "app",
			url: "/movil/acceso-familiar",
			views: {
				"container": {
					template: "<div><react-component name='movilAccesoFamiliar' props='state' /></div>"
				}
			}
		})
		.state("app.movil-cambiar-preguntas", {
			parent: "app",
			url: "/movil/cambiar-preguntas",
			views: {
				"container": {
					template: "<div><react-component name='movilCambiarPreguntas' props='state' /></div>"
				}
			}
		})
		.state("app.movil-autorizacion-modificacion", {
			parent: "app",
			url: "/movil/autorizacion-modificacion",
			views: {
				"container": {
					template: "<div><react-component name='movilAutorizacionModificacion' props='state'/> </div>"
				}
			},
			resolve: {
				param: ["$rootScope", "$stateParams", "$ngRedux", function ($rootScope, $stateParams, $ngRedux) {
					$ngRedux.dispatch({ "type": "GLOBAL_CONECTA_MOVIL", "conectaMovil": true });
				}]

			}
		})
		.state("app.movil-cambiar-contrasenia", {
			parent: "app",
			url: "/movil/cambiar-contrasenia",
			views: {
				"container": {
					template: "<div><react-component name='movilCambiarContrasenia' props='state' /></div>"
				},
				"footer": {
					template: ""
				}
			}
		})
		.state("app.movil-contratos-datos-personales", {
			parent: "app",
			url: "/movil/contratos-datos-personales",
			views: {
				"container": {
					template: "<div><react-component name='movilContratosDP' props='state' /></div>"
				}
			}
		})
		.state("app.movil-contratos-medios-electronicos", {
			parent: "app",
			url: "/movil/contratos-medios-electronicos",
			views: {
				"container": {
					template: "<div><react-component name='movilContratosME' props='state' /></div>"
				}
			}
		})
		.state("app.movil-productos", {
			parent: "app",
			url: "/movil/productos",
			views: {
				"container": {
					template: "<div><react-component name='movilProductos' props='state' /></div>"
				}
			}
		})
		.state("app.movil-seguimiento-reparacion", {
			parent: "app",
			url: "/movil/seguimiento-reparacion",
			views: {
				"container": {
					template: "<div><react-component name='movilReparacion' props='state' /></div>"
				}
			}
		})
		.state("app.movil-seguimiento-reembolsos", {
			parent: "app",
			url: "/movil/seguimiento-reembolsos",
			views: {
				"container": {
					template: "<div><react-component name='movilReembolsos' props='state' /></div>"
				}
			}
		})
		.state("app.movil-beneficios", {
			parent: "app",
			url: "/movil/beneficios",
			views: {
				"container": {
					template: "<div><react-component name='Beneficios' props='state' /></div>"
				}
			}
		})
		.state("app.seguimiento-siniestro-detalle", {
			parent: "app",
			url: "/movil/seguimiento-siniestro",
			views: {
				"container": {
					template: "<div><react-component name='movilDetalleSeguimiento' props='state' /></div>"
				}
			}/*,
			resolve: {
				param: ["$rootScope", "$stateParams", "$ngRedux", function($rootScope, $stateParams, $ngRedux) {
					$ngRedux.dispatch({"type": "SINIESTROS_SET_SELECT_REP", "select": {
							codSiniestro: $stateParams.codSiniestro,
							vin: $stateParams.vin,
							isMobile: true
						}
					});
				}]
			}*/
		})
		/////////// Admin ///////////
		.state("app.admin", {
			parent: "app",
			url: "/secure/admin",
			views: {
				"container": {
					template: "<div><react-component name='adminKM0' props='state' /></div>"
				}
			}
		})
		/////////// AutorizadorDBK///////////
		.state("app.autorizadorDBK", {
			parent: "app",
			url: "/secure/autorizadorDBK",
			views: {
				"container": {
					template: "<div><react-component name='autorizadorDBK0' props='state' /></div>"
				}
			}
		});


	function autenticacion() {
		console.log("AUTENTICACION");
		return new Promise(function (resolve, reject) {
			var unsubscribe = authentication.onAuthStateChanged(function (user) {
				if (user && user.isAnonymous === false) {
					reject("AUTH_AUTHENTICATION");
				} else if (user && user.isAnonymous === true) {
					resolve("AUTH_ANONYMOUS");
				} else {
					authentication.signInAnonymously().then(result => {
						resolve("AUTH_ANONYMOUS");
					});
				}
				unsubscribe();
			});
		});
	}

	function autenticacionAnonima() {
		console.log("AUTENTICACION_ANONIMA");
		return new Promise(function (resolve, reject) {
			var unsubscribe = authentication.onAuthStateChanged(function (user) {
				if (user && user.isAnonymous === true) {
					resolve("AUTH_AUTHENTICATION");
				} else if (user && user.isAnonymous === false) {
					authentication.signOut().then(function () {
						authentication.signInAnonymously().then(result => {
							resolve("AUTH_AUTHENTICATION");
						});
					});
				} else {
					authentication.signInAnonymously().then(result => {
						resolve("AUTH_AUTHENTICATION");
					});
				}
				unsubscribe();
			});
		});
	}
}


// WEBPACK FOOTER //
// ./src/app-routing.js